// extracted by mini-css-extract-plugin
export default {"wrapper":"Policy_wrapper__m+8wf","content":"Policy_content__LMxmo"};